export default __webpack_public_path__ + "12de03217ca690c213c0c308a1cfabc9.svg";